// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AppsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AppsIcon" ref={forwardedRef} {...props}>
      <path d="M3.251 4.25a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm1.5 3.5h3v-3h-3z" />
      <path d="M10.75 4.25a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm1.5 3.5h3v-3h-3z" />
      <path d="M4.251 10.75a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm.5 1.5h3v3h-3z" />
      <path d="M10.75 11.75a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm1.5 3.5h3v-3h-3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AppsIcon = /* @__PURE__ */ Object.assign(AppsIconComponent, {
  displayName: 'AppsIcon',
});
